(function() {

  if (!document.getElementById('map')) {
    return;
  }

  const noPoi = [
    {
      featureType: "poi",
      stylers: [
        {visibility: "off"}
      ]
    }
  ];

  const autoCompleteInit = (field) => {
            
    const locationFields = {
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        postal_code: 'short_name',
        country: 'short_name'
    };

    let form = $('.top-nav form');

    let autocomplete, autocompleteListener;

    const setForm = (targetForm) => {
        form = targetForm;
    }

    const setCookie = (name, value, days) => {

        const expireDate = new Date(new Date().getTime());

        expireDate.setDate(expireDate.getDate() + days);
        document.cookie = name + '=' + value + ';expires=' + expireDate.toString() + ' ;path=/;';
    }

    const disableGoogleAutocomplete = () => {

        if ( autocomplete === undefined ) {
            return;
        }

        google.maps.event.removeListener(autocompleteListener);
        google.maps.event.clearInstanceListeners(autocomplete);

        $('.pac-container').remove();

        $(form).find('.autocomplete').val(null);
    }

    const changeCountry = () => {

        const $currentForm = $(form).find('.selected');
        let countryCode;

        disableGoogleAutocomplete();

        if ( $currentForm[0] === undefined ) {
            return;
        }

        switch ( $currentForm[0].dataset.attr ) {
            case 'Canada':
                countryCode = 'ca';
                break;
            case 'Mexico':
                countryCode = 'mx';
                break;
            case 'Dominican Republic':
                countryCode = 'do';
                break;
            case 'Puerto Rico':
                countryCode = 'pr';
                break;
            default:
                countryCode = 'us'
        }

        const autocompleteArgs = {
            types: ['(regions)'], // @see https://developers.google.com/maps/documentation/javascript/supported_types#table3
            componentRestrictions: {
                country: countryCode
            }
        };

        initAutocomplete(autocompleteArgs);
    }

    const createSearch = (location) => {

        const locationDetails = {};

        if ( ! location.address_components ) {
            return false;
        }

        for ( let i = 0; i < location.address_components.length; i++ ) {

            const addressComponents = location.address_components[i];
            const type = addressComponents.types[0];

            if ( locationFields[type] ) {
                locationDetails[type] = addressComponents[locationFields[type]]
            };
        }

        if ( locationDetails.postal_code ) {
            return locationDetails.postal_code;
        }

        if ( locationDetails.locality ) {
            return locationDetails.locality + ', ' + locationDetails.administrative_area_level_1;
        }

        if ( locationDetails.administrative_area_level_2 ) {
            return locationDetails.administrative_area_level_2 + ', ' + locationDetails.administrative_area_level_1;
        }

        return locationDetails.administrative_area_level_1 + ', ' + locationDetails.country;
    }

    // Fired in onclick method
    const geolocate = (targetBtn) => {

        $(targetBtn).addClass('active');

        if ( navigator.geolocation ) {

            const currentForm = $(targetBtn).parents('.row').find('form');
            const geocoder = new google.maps.Geocoder;

            navigator.geolocation.getCurrentPosition(
                // success
                (pos) => {

                    const coordinates = {
                        lat: pos.coords.latitude,
                        lng: pos.coords.longitude
                    };

                    const geocodeArgs = {
                        location: coordinates
                    };

                    geocoder.geocode(
                        geocodeArgs,
                        ( result, status ) => {

                            if ( status === google.maps.GeocoderStatus.OK ) {

                                const searchData = createSearch(result[0]);

                                setCookie('coordinate_CC', searchData, 365);

                                $(currentForm).find('.finalResult').val(searchData);
                                $(currentForm).find('.autocomplete').val(searchData);
                                $(currentForm).find('.lf-finder').click();
                            }
                        }
                    );
                },
                // error
                (error) => {
                    console.log(error);
                }
            );
        }
        else {
            console.log('error');
        }
    }

    const fillInAddress = () => {

        const searchData = createSearch( autocomplete.getPlace() );

        $(form).find('.finalResult').val(searchData);
        $(form).find('.lf-finder').click();
    }

    const initAutocomplete = (initArgs) => {

        disableGoogleAutocomplete();

        const defaultArgs = {
            types: ['(regions)'],
            componentRestrictions: {
                country: 'us'
            }
        };

        const autocompleteArgs = initArgs || defaultArgs;
        const autocompleteForm = $(form).find('.autocomplete')[0];

        autocomplete = new google.maps.places.Autocomplete( autocompleteForm, autocompleteArgs ) ;
        autocompleteListener = autocomplete.addListener( 'place_changed', fillInAddress );
    }

    $(document).on('focus', '.autocomplete', function() {

        setForm( $(this).parents('form') );
        changeCountry();

        $('.lf-dropdown ul').css('display', 'none');

        if ( $(this).attr('data-block') ) {
            $(this).parents('.dropdown-menu').css('display', 'block');
        }
    });

    $(document).on('tap', 'body', (e) => {

        e.stopPropagation();

        if ( ! $(e.target).hasClass('dropdown-menu') &&
        $(e.target).parents('.dropdown-menu').length === 0 ) {
            $('.dropdown-menu').css('display', '');
        }
    });

    $('.lf-dropdown li').on('click', function() {

        const $parent = $(this).parent().parent().parent();

        setForm( $parent.parents('form') );
        changeCountry();
    });

    $('.lf-dropdown li').not(':has(a)').keydown(function(e) {

        if ( e.keyCode !== 13 && e.keyCode !== 32 ) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const $parent = $(this).parent().parent().parent();

        setForm( $parent.parents('form') );
        changeCountry();
    });

    $('.lf-dropdown .selected').on('click', function() {

        const $parent = $(this).parent();
        const current = $(this).attr('data-current');

        $parent.find('li').show();
        $parent.find('ul')
            .stop()
            .slideToggle()
            .find('li')
            .eq(current)
            .hide();

        setForm( $parent.parents('form') );
        changeCountry();
    });

    changeCountry( $(form).find(['class="selected"']) );

    field.focus();
}

  function loadScript(url) {
    return new Promise((resolve, reject) => {
        const element = document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        element.onload = () => resolve();
        element.onerror = () => reject();
        document.head.appendChild(element);
    });
  }

  async function gMapsInit(){

    if(typeof google === 'undefined'){
        const apiKey = 'AIzaSyAHtaRI8YL1MTUwPWK4p5NToTZH3elNDmI';
        var url = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=Function.prototype`;
        let gmaps = await loadScript(url);
        google.maps.event.addDomListener(window, 'load', initMap);
    } else{
        google.maps.event.addDomListener(window, 'load', initMap);
        console.log('already loaded!');
    }

  }

  /**
   * Initialize custom Google Map
   * settings are pulled from data attributes
   */
  const initMap = () => {

    const mapCanvas = document.getElementById('map');
    const tooltipContent = mapCanvas.closest('.map__wrapper').querySelector('.map__content');
    const mapCoords = mapCanvas.dataset.coordinates.split(',');
    const mapIcon = mapCanvas.dataset.icon;

    const mapOptions = {
      center: new google.maps.LatLng(mapCoords[0], mapCoords[1]),
      zoom: 13,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      draggable: false,
      scaleControl: false,
      scrollwheel: true,
      navigationControl: false,
      streetViewControl: false,
      zoomControl: true,
      styles: noPoi
    };

    const map = new google.maps.Map(mapCanvas, mapOptions);

    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(mapCoords[0], mapCoords[1]),
      map: map,
      title: '',
      icon: mapIcon
    });

    google.maps.event.addListenerOnce(map, 'idle', () => {
      mapCanvas.querySelector('iframe').title = 'Google Maps';
    });

    if (tooltipContent) {

      const contentString = '<div id="content">' + tooltipContent.innerHTML + '</div>';
      const infowindow = new google.maps.InfoWindow({
        content: contentString
      });

      marker.addListener('click', () => {
        infowindow.open(map, marker);

        _st.render();
        _st.triggerPageHit();
      });
    }

    autoCompleteInit($('.autocomplete'));
  }
  gMapsInit();
})();
